import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'

export const useStyles = makeStyles({
  '@global': {
    '& .PrivateDatePickerToolbar-penIcon': {
      display: 'none'
    },
    '.MuiPickersBasePicker-container': {
      '& .MuiPickersToolbar-toolbar': {
        backgroundColor: '#252525',
        borderRadius: '10px 10px 0 0'
      },
      '& .MuiPickersDay-current': {
        border: '1px solid #252525'
      },
      '& .MuiPickersDay-daySelected': {
        backgroundColor: '#252525',
        color: 'rgb(255, 255, 255)',
        '&:hover': {
          backgroundColor: '#252525'
        }
      }
    }
  },
  root: {
    [appTheme.breakpoints.up('md')]: {
      margin: '10px'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: ' rgba(0, 0, 0, 0.2)'
      },
      '&:hover fieldset': {
        borderColor: '#006BD7'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#006BD7'
      }
    },

    '& .MuiFilledInput-root': {
      background: 'rgba(0, 0, 0, 0.2)'
    },
    '& .PrivateDatePickerToolbar-penIcon': {
      visibility: 'hidden'
    }
  },
  timeHandler: {
    background: 'white',
    borderRadius: '0.5rem',
    flexDirection: 'row',
    [appTheme.breakpoints.down('md')]: {
      flexDirection: 'column',
      maxWidth: '276px'
    },
    [appTheme.breakpoints.down('lg')]: {
      flexDirection: 'row'
    },
    [appTheme.breakpoints.down('xl')]: {
      flexDirection: 'row'
    }
  },
  timeHandlerContainer: {
    maxHeight: '404px',
    alignItems: 'flex-start',
    paddingTop: '3.5rem',
    paddingLeft: '2.5rem',
    [appTheme.breakpoints.down('lg')]: {
      paddingTop: '2.5rem',
      paddingLeft: '1.5rem'
    },
    [appTheme.breakpoints.down('md')]: {
      maxWidth: '276px',
      maxHeight: '202px'
    }
  },
  datepickerWrapper: {
    // margin: 'auto',
    maxWidth: '280px',
    padding: '0px',
    background: 'white',
    borderRadius: '4px'
  },
  timeSlot: {
    gridAutoFlow: 'row',
    justifyContent: 'space-between',
    minWidth: '100%',
    maxWidth: '100%',
    maxHeight: '90%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'inherit'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#808080',
      borderRadius: '1.25rem',
      borderColor: '#E8E8E8'
    },
    paddingRight: '2.5rem',
    [appTheme.breakpoints.down('lg')]: {
      paddingRight: '1rem'
    },
    [appTheme.breakpoints.down('md')]: {
      maxHeight: '75%',
      rowGap: '0rem'
    }
  },
  infoWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 'auto',
    width: '70%',
    padding: '1rem 1rem 0.5rem 1rem',
    background: 'rgba(0, 107, 215, 0.03)',
    borderRadius: '0.5rem',
    [appTheme.breakpoints.down('lg')]: {
      marginBottom: '0.75rem',
      width: '90%'
    },
    [appTheme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '-1.5rem'
      // paddingBottom:"0rem",
    }
  },
  eventTitle: {
    maxWidth: '276px',
    [appTheme.breakpoints.down('md')]: {
      margin: 'auto'
    }
  }
})
